import React from 'react';
import { FormattedMessage } from 'react-intl';

export const viewOptions = (
    <FormattedMessage id="pdpMobileShippingHelpers.view_options" defaultMessage="View Options" />
);

export const requestQuote = (
    <FormattedMessage
        id="pdpMobileShippingHelpers.request_quote"
        defaultMessage="Request a quote"
    />
);

export const viewRequest = (
    <FormattedMessage id="pdpMobileShippingHelpers.view_request" defaultMessage="View Request" />
);

export const contactSeller = (
    <FormattedMessage
        id="pdpMobileShippingHelpers.contact_seller"
        defaultMessage="Contact Seller"
    />
);
